// Common action types
export const rootTypes = {
    CLEAR_ROOT_STATE: 'CLEAR_ROOT_STATE',
};

// Login types
export const loginTypes = {
    LOGIN: 'login/LOGIN',
    LOGIN_ID: 'login/LOGIN_ID',
    GET_USER: 'login/GET_USER',
    EDIT_USER: 'login/EDIT_USER',
    EDIT_PASSWORD: 'login/EDIT_PASSWORD',
    RESET_PASSWORD: 'login/RESET_PASSWORD',
    ERROR_GOTO_LOGIN: 'login/ERROR_GOTO_LOGIN',
    REDIRECT_TO_ID: 'login/REDIRECT_TO_ID',
    LOGOUT: 'login/LOGOUT',
    LOGOUT_BO: 'login/LOGOUT_BO',
    LOGOUT_ID: 'login/LOGOUT_ID',
    CLEAR_ERROR: 'login/CLEAR_ERROR',
};

// Home types
export const homeTypes = {
    REDIRECT_HOME: 'home/REDIRECT_HOME',
    USERSTORAGE_GET: 'home/USERSTORAGE_GET',
    // Add other home types here
};

// Error types
export const errorTypes = {
    DISPATCH_ERROR: 'errorHandler/DISPATCH_ERROR',
    // DISPATCH_ERROR: types.DISPATCH_ERROR, //TODO: improve getting the name cause cycle
    // Add other error types here
};

// Pending operation types
export const pendingTypes = {
    START_PENDING_OPERATION: 'pendingOperations/START_PENDING_OPERATION',
    STOP_PENDING_OPERATION: 'pendingOperations/STOP_PENDING_OPERATION',
};
